import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Link } from "react-router-dom";
import { TrendingUp, TrendingDown, BarChart3 } from "lucide-react";

export default function Stocks() {
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = () => api.get("/stocks/list").then((r) => setStocks(r.data)).catch(() => {}).finally(() => setLoading(false));
    load();
    const interval = setInterval(load, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="pt-10 pb-20">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <BarChart3 className="w-8 h-8 text-yellow-400 mx-auto mb-4" />
          <h1 className="font-display font-bold text-4xl text-[var(--text-primary)]">Stocks</h1>
          <p className="mt-3 text-[var(--text-secondary)]">Live prices for major US stocks, updated every minute.</p>
        </div>

        {loading ? (
          <p className="text-center text-[var(--text-tertiary)] font-mono text-sm">Loading stocks...</p>
        ) : (
          <div className="bg-[var(--bg-panel)] border border-[var(--border-soft)] rounded-xl overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left border-b border-[var(--border-soft)] text-xs font-mono uppercase tracking-widest text-[var(--text-tertiary)]">
                  <th className="p-4">Company</th>
                  <th className="p-4 text-right">Price</th>
                  <th className="p-4 text-right">Change</th>
                  <th className="p-4 text-right hidden sm:table-cell">Day High</th>
                  <th className="p-4 text-right hidden sm:table-cell">Day Low</th>
                </tr>
              </thead>
              <tbody>
                {stocks.map((s) => (
                  <tr key={s.symbol} className="border-b border-[var(--border-soft)] last:border-0 hover:bg-[var(--bg-elevated)] transition">
                    <td className="p-4">
                      <Link to={"/stocks/" + s.symbol} className="block">
                        <div className="font-bold text-[var(--text-primary)]">{s.symbol}</div>
                        <div className="text-xs text-[var(--text-tertiary)]">{s.name}</div>
                      </Link>
                    </td>
                    <td className="p-4 text-right font-mono text-[var(--text-primary)]">${s.price?.toFixed(2)}</td>
                    <td className="p-4 text-right">
                      <span className={"font-mono text-xs font-bold flex items-center justify-end gap-1 " + (s.change_pct >= 0 ? "text-green-400" : "text-red-400")}>
                        {s.change_pct >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                        {s.change_pct >= 0 ? "+" : ""}{s.change_pct?.toFixed(2)}%
                      </span>
                    </td>
                    <td className="p-4 text-right font-mono text-xs text-[var(--text-tertiary)] hidden sm:table-cell">${s.high?.toFixed(2)}</td>
                    <td className="p-4 text-right font-mono text-xs text-[var(--text-tertiary)] hidden sm:table-cell">${s.low?.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <p className="text-xs text-[var(--text-tertiary)] text-center mt-8">
          Data from Finnhub. Prices may be delayed. Not financial advice.
        </p>
      </div>
    </div>
  );
}